/* eslint complexity:0 */ // TODO PINT-4748
// uses ./appDetails.less
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import ReactMarkdown from 'react-markdown';
import APPACTIONS_DISPLAY_VARIANT from '../../enums/APPACTIONS_DISPLAY_VARIANT';
import Icon from '../common/Icon';
import Loading from '../common/Loading';
import Layer from '../common/Layer';
import AppScreenshots from './appScreenshots/AppScreenshots';

import { fetchApp, copyPermalink } from './appDetailsActionCreators';
import { clickLink } from '../tracking/trackingActionCreators';

import AppActions from '../common/appActions/AppActions';
import DesktopFeedback from '../appFeedback/DesktopFeedback';
import MobileFeedback from '../appFeedback/MobileFeedback';
import AppDetailsAuthorsMeta from './AppDetailsAuthorsMeta';
import CopyToClipboardButton from './CopyToClipboardButton';
import InfoBox from '../common/InfoBox';
import { withRouter } from '../../withRouter';

const getBoxContent = (appName) =>
    `Viewer Only Permission is active on this domain. The integration, ‘${appName}’ has not yet been tested to be compliant with this feature. Please reach out to the 3rd party and/or Egnyte support requesting to test/approve the integration before activation. If activated without prior approval, potential issues can arise like unknown error states and permission elevation scenarios.`;

class AppDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
        this.clickLink = this.clickLink.bind(this);
        this.dropdownClick = this.dropdownClick.bind(this);
        this.close = this.close.bind(this);
        this.copyPermalink = this.copyPermalink.bind(this);
    }

    componentDidMount() {
        if (!this.props.isFetching) {
            this.props.dispatchFetchApp(this.props.match.params.appId, this.props.user.pageDomain);
        }
    }

    componentDidUpdate() {
        if (!this.props.isFetching && !this.props.app) {
            this.close();
        }
        if (this.props.shouldUpdate) {
            this.props.dispatchFetchApp(this.props.match.params.appId, this.props.user.pageDomain);
        }
    }

    copyPermalink() {
        this.props.dispatchCopyPermalink(this.props.app.appId);
    }

    dropdownClick() {
        this.setState((prevState) => ({
            isDropdownOpen: !prevState.isDropdownOpen,
        }));
    }

    clickLink(e) {
        this.props.dispatchClickLink(this.props.app.appId, e.target.getAttribute('href'));
    }

    close() {
        this.props.history.push(this.props?.history?.location?.state?.prevPath ?? '/apps');
    }

    render() {
        const dropdownData = {
            isOpen: this.state.isDropdownOpen,
            onClick: this.dropdownClick,
        };
        const pageDomain = this.props.user && this.props.user.domain;
        const isConnectSession = this.props.user && this.props.user.connectSession;
        const onClickLink = this.clickLink;

        return (
            <Layer className="ast-app-details-wrapper">
                <Loading isLoaded={!this.props.isFetching}>
                    {this.props.app ? (
                        <div className="ast-app-details">
                            <NavigationBar goBack={this.close} />
                            {!this.props.app.compatibleFeatures.find((feature) => feature === 'viewerOnly') && (
                                <div className="ast-app-details__info-box-wrapper">
                                    <InfoBox content={getBoxContent(this.props.app.name)} title="Check compatibility" />
                                </div>
                            )}
                            <AppDetailsHeader>
                                <AppLogoSection app={this.props.app} />
                                <AppTitleSection
                                    app={this.props.app}
                                    dropdownData={dropdownData}
                                    pageDomain={pageDomain}
                                    appGroups={this.props.appGroups}
                                    onClickLink={onClickLink}
                                />
                            </AppDetailsHeader>
                            <AppDetailsContent app={this.props.app} />
                            <AppDetailsFooter
                                app={this.props.app}
                                clickLink={this.clickLink}
                                copyPermalink={this.copyPermalink}
                                permalink={
                                    isConnectSession
                                        ? `https://${this.props.user.pageDomain}/app/index.do#appstore/addons-integrations/apps/${this.props.app.appId}`
                                        : null
                                }
                            />
                        </div>
                    ) : null}
                </Loading>
            </Layer>
        );
    }
}

function NavigationBar({ goBack }) {
    return (
        <div className="ast-app-details__navigation-bar-wrapper">
            <div className="ast-app-details__navigation-bar">
                <span className="ast-app-details__navigation-bar-back-button" onClick={goBack}>
                    <Icon alias="chevron-left" /> Back
                </span>
            </div>
        </div>
    );
}

NavigationBar.propTypes = {
    goBack: PropTypes.func.isRequired,
};

function AppDetailsHeader(props) {
    return (
        <div className="ast-app-details__header-wrapper">
            <div className="ast-app-details__header">{props.children}</div>
        </div>
    );
}

AppDetailsHeader.propTypes = {
    children: PropTypes.node.isRequired,
};

function AppLogoSection({ app }) {
    return (
        <div className="ast-app-details__header-logo-section">
            <img className="ast-app-details__header-logo-section__logo" src={app.appLogo} />
        </div>
    );
}

AppLogoSection.propTypes = {
    app: PropTypes.object,
};

function AppTitleSection({ app, dropdownData, pageDomain, appGroups, onClickLink }) {
    return (
        <div className="ast-app-details__header-title-section">
            <h1 className="ast-app-details__header-title-section-app-name">{app.name}</h1>
            <AppDetailsAuthorsMeta supportedBy={app.supportedBy} company={app.company} onClickLink={onClickLink} />
            <AppActions
                variant={APPACTIONS_DISPLAY_VARIANT.APP_DETAILS}
                className="ast-app-details__header-actions"
                dropdownData={dropdownData}
                pageDomain={pageDomain}
                appGroups={appGroups}
                {...app}
            />
        </div>
    );
}

AppTitleSection.propTypes = {
    app: PropTypes.object,
    dropdownData: PropTypes.object,
    pageDomain: PropTypes.string,
    appGroups: PropTypes.array,
    onClickLink: PropTypes.func.isRequired,
};

function LinkRenderer(props) {
    return (
        <a href={props.href} target="_blank" rel="noreferrer">
            {props.children}
        </a>
    );
}

function AppDetailsContent({ app }) {
    return (
        <div className="ast-app-details__content-wrapper">
            <div className="ast-app-details__content">
                <div className="ast-app-details__content-description">
                    <h2>Overview</h2>
                    <div className="ast-app-details--newline-support">
                        <ReactMarkdown components={{ a: LinkRenderer }}>
                            {app.longDescription || app.description}
                        </ReactMarkdown>
                    </div>
                </div>
                <div className="ast-app-details__content-media">
                    <AppScreenshots
                        className="ast-app-details__content-screenshots"
                        logo={app.appLogo}
                        {...app.screenshots}
                    />
                </div>
            </div>
        </div>
    );
}

AppDetailsContent.propTypes = {
    app: PropTypes.object,
};

function AppDetailsFooter({ app, clickLink, copyPermalink, permalink }) {
    const supportLink = app && app.support && app.support.web;
    const userManual = app && app.userManual;

    return (
        <div className="ast-app-details__footer-wrapper">
            <div className="ast-app-details__footer">
                <MediaQuery query="(max-width: 1064px)">
                    <MobileFeedback className="ast-app-details__footer-feedback" appId={app.appId} />
                </MediaQuery>
                <CopyToClipboardButton copyPermalink={copyPermalink} permalink={permalink} />
                <MediaQuery query="(min-width: 1065px)">
                    <DesktopFeedback className="ast-app-details__footer-feedback" appId={app.appId} />
                </MediaQuery>
                <div className="ast-app-details__footer-links">
                    {supportLink && (
                        <a
                            href={supportLink}
                            className="ast-app-details__footer-link"
                            target="_blank"
                            rel="noreferrer"
                            onClick={clickLink}
                        >
                            <Icon alias="open-in-new" />
                            &nbsp;<span>Customer Support</span>
                        </a>
                    )}
                    {userManual && (
                        <a
                            href={userManual}
                            className="ast-app-details__footer-link"
                            target="_blank"
                            rel="noreferrer"
                            onClick={clickLink}
                        >
                            <Icon alias="open-in-new" />
                            &nbsp;<span>User Manual</span>
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

AppDetailsFooter.propTypes = {
    app: PropTypes.object,
    clickLink: PropTypes.func,
    copyPermalink: PropTypes.func,
    permalink: PropTypes.string,
};

AppDetails.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    app: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    dispatchFetchApp: PropTypes.func.isRequired,
    dispatchClickLink: PropTypes.func.isRequired,
    dispatchCopyPermalink: PropTypes.func.isRequired,
    appGroups: PropTypes.array,
    shouldUpdate: PropTypes.bool,
    user: PropTypes.object,
};

const mapDispatchToProps = {
    dispatchFetchApp: fetchApp,
    dispatchClickLink: clickLink,
    dispatchCopyPermalink: copyPermalink,
};

const mapStateToProps = (state) => {
    const appGroups = state.appDetails.app ? state.appDetails.app.groups : [];

    return { ...state.appDetails, user: state.user, appGroups };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppDetails));
